import { v4 as uuid } from 'uuid';

export const util = {
  /**
   * Generate a UUID.
   */
  generateUUID() {
    return uuid();
  },

  /**
   * Generates a full style formatted date and time (e.g. 01/01/2024, 10:00:00 AM).
   */
  formatDateTime(timestamp: number) {
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }).format(timestamp);
  },

  getFormattedDate(timestamp: number) {
    const formattedDateTime = this.formatDateTime(timestamp);

    return formattedDateTime.split(',')[0].trim();
  },

  getFormattedTime(timestamp: number) {
    const formattedDateTime = this.formatDateTime(timestamp);

    return formattedDateTime.split(',')[1].trim();
  },

  /**
   * Creates deep copy of conversationEntries for searching.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  createDeepCopy(conversationEntries: any) {
    return JSON.parse(JSON.stringify(conversationEntries));
  },
};

export const getFormattedTime = (timeStamp: number) => {
  return new Date(timeStamp).toLocaleTimeString('en-us', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
};

export const formatDateWithOrdinal = (date: Date): string => {
  const day: number = date.getDate();
  const month: string = date.toLocaleString('default', { month: 'short' }); // e.g., 'Dec'
  const year: number = date.getFullYear();

  const getOrdinal = (n: number): string => {
    const s = ['th', 'st', 'nd', 'rd'];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  return `${getOrdinal(day)} ${month} ${year}`;
};
